import ComingSoon from "./ComingSoon";

function Office() {
    return (
      <div>
        <ComingSoon />
      </div>
    );
  }
  
  export default Office;
  